import { useEffect, useState } from "react";
import { apiClient } from "@/context/AuthContext";
import SignaturePad from "@/components/SignaturePad";
import StampBuilder from "@/components/StampBuilder";
import { AlertTriangle, Check, Loader2, Pen, UserRound, X } from "lucide-react";

export default function SignReportModal({ report, onClose, onToast, onSigned }) {
  const [profile, setProfile] = useState({});
  const [signatureB64, setSignatureB64] = useState("");
  const [stampB64, setStampB64] = useState("");
  const [roleLabel, setRoleLabel] = useState("Danışman");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => { (async () => {
    try {
      const { data } = await apiClient.get("/auth/me");
      setProfile(data);
      if (data.signature_b64) setSignatureB64(data.signature_b64);
      if (data.stamp_b64) setStampB64(data.stamp_b64);
    } catch { /* ignore */ }
  })(); }, []);

  const upd = (k, v) => setProfile((p) => ({ ...p, [k]: v }));

  const submit = async () => {
    setError("");
    if (!signatureB64) { setError("İmza boş olamaz"); return; }
    setLoading(true);
    try {
      const payload = {
        signature_b64: signatureB64,
        stamp_b64: stampB64 || null,
        role_label: roleLabel,
        full_name: profile.name,
        title: profile.title,
        chamber: profile.chamber,
        license_no: profile.license_no,
        phone: profile.phone,
      };
      await apiClient.post(`/reports/${report.id}/sign`, payload);
      onToast?.("Rapor imzalandı — QR'lı imza sayfası eklendi");
      onSigned?.();
      onClose?.();
    } catch (err) {
      setError(err?.response?.data?.detail || "İmzalama başarısız");
    } finally { setLoading(false); }
  };

  return (
    <div className="modal-backdrop" data-testid="sign-modal">
      <div className="modal wide-modal" style={{maxWidth: 820}}>
        <div className="modal-head">
          <div><div className="eyebrow">RAPOR İMZA · {report.code}</div><h2>İmza + Kaşe</h2></div>
          <button className="icon-button" onClick={onClose} data-testid="sign-close"><X size={17}/></button>
        </div>
        <div className="step-body">
          <div className="row-fields">
            <label>Ad Soyad<input value={profile.name || ""} onChange={(e) => upd("name", e.target.value)} data-testid="sign-name"/></label>
            <label>Ünvan<input value={profile.title || ""} onChange={(e) => upd("title", e.target.value)} data-testid="sign-title"/></label>
            <label>Rol<select value={roleLabel} onChange={(e) => setRoleLabel(e.target.value)} data-testid="sign-role">
              <option value="Danışman">Danışman</option>
              <option value="Bina Sahibi">Bina Sahibi</option>
              <option value="İşletme Yöneticisi">İşletme Yöneticisi</option>
              <option value="Teknik Müşavir">Teknik Müşavir</option>
            </select></label>
          </div>
          <div className="row-fields">
            <label>Oda<input value={profile.chamber || ""} onChange={(e) => upd("chamber", e.target.value)} data-testid="sign-chamber"/></label>
            <label>Sicil No<input value={profile.license_no || ""} onChange={(e) => upd("license_no", e.target.value)} data-testid="sign-license"/></label>
            <label>Telefon<input value={profile.phone || ""} onChange={(e) => upd("phone", e.target.value)} data-testid="sign-phone"/></label>
          </div>

          <div className="eyebrow" style={{marginTop:4}}>İMZA (mouse / parmak)</div>
          <SignaturePad value={signatureB64} onChange={setSignatureB64} height={160}/>

          <div className="eyebrow" style={{marginTop:4}}>KAŞE</div>
          <StampBuilder
            initial={{
              full_name: profile.name, title: profile.title,
              chamber: profile.chamber, license_no: profile.license_no,
            }}
            onChange={(d) => setStampB64(d)}
          />

          {error && <div className="auth-error" data-testid="sign-error"><AlertTriangle size={14}/> {error}</div>}
          <div className="step-actions">
            <button type="button" className="secondary-btn" onClick={onClose}>İptal</button>
            <button type="button" className="primary-btn" onClick={submit} disabled={loading || !signatureB64} data-testid="sign-submit">
              {loading ? <Loader2 size={14} className="spin"/> : <Pen size={14}/>} İmzayı rapora ekle
            </button>
          </div>
          <small className="legal-foot"><Check size={13}/> İmzalanmış sürüm indirmede ve public linkte otomatik servis edilir, audit log'a düşer.</small>
        </div>
      </div>
    </div>
  );
}
